export const roundToNearest = (value: number): number => {
    const EPSILON = 1e-10;
    if (Math.abs(value) < EPSILON) {
        return 0;
    }
    return Math.round(value);
};
